import React, { Component, Fragment } from 'react'
import StockDisplay from './StockDisplay'
import StockInputs from './StockInputs'
import StockTable from './StockTable'

export default class StockForm extends Component {
	componentDidMount() {
		this.props.clearStoreStock()
	}

	componentWillUnmount = () => {
		const { confirmedStock, handleCancelApi } = this.props
		if (confirmedStock === null) {
			handleCancelApi()
		}
	}

	render() {
		const { productStock, params, idOperacion, referenceItem } = this.props
		const showInputs = productStock ? productStock.ind_series : 0

		return (
			<Fragment>
				<StockDisplay
					handleCancelStock={this.props.handleCancelStock}
					handleConfirmStock={this.props.handleConfirmStock}
				/>
				{showInputs > 0 && (
					<StockInputs
						idOperacion={idOperacion}
						referenceItem={referenceItem}
						params={params}
						handleSetErrorBarCode={this.props.handleSetErrorBarCode}
					/>
				)}
				<StockTable
					idOperacion={idOperacion}
					params={params}
					handleChangeTable={this.props.handleChangeTable}
					handleSetErrorBarCode={this.props.handleSetErrorBarCode}
				/>
			</Fragment>
		)
	}
}
